<section *ngIf="UserPolicyDetails?.isDataAvailable" class="bg-white calculations b5containeradjust pt-4 pb-4  mb-bg-2">

  <div class="container">
    <h3 class="fw-bold text-start px-3">Understand Your Cover</h3>

    <div class="px-md-3 px-3">
      <div class="section-box">
        <div class="col-md-2 col-12">
          <img  src="../../assets/images/logoJM.png" alt="cover image" class="img-fluid" />
          <div class="cover-text pt-3">
            Just Money Protect (Pty) Ltd (“JustMoney Protect”) is a licensed Financial Services Provider – FSP No. 32984.
          </div>
        </div>
        
        <div class="line-section"></div>

        <div class="col-md-10 col-12 d-flex justify-content-between align-items-center flex-column">
          <div class="align-self-md-center align-self-start cover_font">Your cover</div>
          <div class="d-flex justify-content-between align-items-center flex-wrap my-3">
              <div class="inner-box-group"
                   [ngClass]="{
                     'centered-group': coverTypes?.length === 1,
                     'spaced-group': coverTypes?.length > 1
                   }">
        
                  <div class="inner-box" *ngIf="UserPolicyDetails?.creditLifePolicyResponse != null">
                    <div class="inner-box-heading">Credit Life Cover</div>
                    <div class="line-break"></div>
                    <div class="mt-3">Includes:</div>
                    <div class="cover-list">
                      <span class="cover-tag">Death</span>
                      <span class="cover-tag">Permanent Disability</span>
                      <span class="cover-tag">Temporary Disability</span>
                      <span class="cover-tag">Critical Illness</span>
                      <span class="cover-tag">Loss of Income*</span>
                    </div>
                  </div>


                  <div class="inner-box" *ngIf="UserPolicyDetails?.lifeCoverPolicyResponse != null">
                    <div class="inner-box-heading">Life Cover</div>
                    <div class="line-break"></div>
                    <div class="mt-3">Includes:</div>
                    <div class="cover-list">
                      <span class="cover-tag">Death</span>
                      <span class="cover-tag">Permanent Disability</span>
                      <span class="cover-tag">Critical Illness</span>
                    </div>
                  </div>
                  
                  <div class="inner-box" *ngIf="UserPolicyDetails?.legalCoverPolicyResponse != null">
                    <div class="inner-box-heading">Legal Insurance Cover</div>
                    <div class="line-break"></div>
                    <div class="mt-3">Includes:</div>
                    <div class="cover-list">
                      <span class="cover-tag">Civil Action</span>
                      <span class="cover-tag">Criminal Charges</span>
                      <span class="cover-tag">Labour Matters</span>
                    </div>
                  </div>

                  <div class="inner-box" *ngIf="UserPolicyDetails?.funeralCoverPolicyResponse != null">
                    <div class="inner-box-heading">Funeral Cover</div>
                    <div class="line-break"></div>
                    <div class="mt-3">Includes:</div>
                    <div class="cover-list">
                      <span class="cover-tag">Death</span>
                      <span class="cover-tag">Funeral Expenses</span>
                    </div>
                  </div>
              </div>
          </div>
          <button id="btn_userJourney_insuranceHub_dashboardPage" name="btn_userJourney_insuranceHub_dashboardPage" class="cover-btn" routerLink="/portal/insurance">
            View insurance details
          </button>
        </div>
      </div>
    </div>
    

  </div>
</section>